/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { DisplayHtmlContent, ReadMoreBlock } from 'sarsaparilla';
import { ContentProps } from '../props/contents';

function Overview({ overview = [] }) {
    const [item] = overview;
    const paragraphs = item?.paragraphs;

    return (
        <ReadMoreBlock id="parkpass-pass-overview" lineHeight={23} linesToShow={5}>
            {paragraphs?.map((paragraph, index) => {
                return (
                    <DisplayHtmlContent
                        key={`overview-paragraph-${index}`}
                        html={`<div>${paragraph}</div>`}
                    />
                );
            })}
        </ReadMoreBlock>
    );
}

Overview.propTypes = {
    overview: PropTypes.arrayOf(ContentProps),
};

export default Overview;
